var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5626_9854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#FFB700"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5626_9854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.6663,
    cy: 4.16634,
    r: 13.3333,
    fill: "#FFE75F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5626_9854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.6663,
    cy: -4.16667,
    r: 10.8333,
    fill: "#FFEF93"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_5626_9854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -2.91634,
    cy: 30.4167,
    r: 15.4167,
    fill: "#FF006B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.28711 14.1582L6.28265 14.1828L6.27148 14.1738L6.28711 14.1582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28711 14.1582L6.28265 14.1828L6.27148 14.1738L6.28711 14.1582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6363 8.70599C15.6363 11.7809 10.0267 15.1882 10.0267 15.1882C10.0267 15.1882 9.05851 14.6106 7.94074 13.7027L10.2137 10.6174L10.0059 10.4096L7.28214 13.1334L7.27383 13.123L6.55704 13.8377L6.55081 13.8647L6.53627 13.8793L6.54666 13.8876L6.28983 15.0785C6.27539 15.1454 6.22357 15.198 6.15683 15.2134C6.06632 15.2343 5.9751 15.1816 5.94805 15.0927L5.85065 14.7727L5.66511 15.7004C5.65158 15.768 5.59968 15.8214 5.53247 15.837C5.44256 15.8577 5.35195 15.8053 5.32508 15.717L5.22736 15.396L5.0397 16.3343C5.02746 16.3954 4.98052 16.4438 4.91972 16.4578C4.82846 16.4789 4.7389 16.4168 4.72663 16.3239L4.60407 15.396L3.67611 15.2734C3.58326 15.2611 3.52115 15.1716 3.54221 15.0803C3.55624 15.0195 3.60458 14.9726 3.66577 14.9603L4.60407 14.7727L4.28299 14.6749C4.19472 14.6481 4.14232 14.5575 4.16307 14.4676C4.17858 14.4003 4.23202 14.3484 4.29967 14.3349L5.22736 14.1494L4.90802 14.0522C4.81877 14.025 4.76579 13.9334 4.78676 13.8425C4.80209 13.7761 4.85411 13.7243 4.9206 13.7093L6.09997 13.443L6.81675 12.7262C5.55355 11.544 4.39631 10.0938 4.39631 8.70599C4.39631 7.00233 5.76755 5.65187 7.45042 5.65187C9.00865 5.65187 10.0267 6.77379 10.0267 6.77379C10.0267 6.77379 11.0239 5.65187 12.5822 5.65187C14.265 5.65187 15.6363 7.02311 15.6363 8.70599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4583 4.14426C14.4046 4.16377 14.3689 4.21476 14.3689 4.27185C14.3689 4.33718 14.4154 4.39324 14.4797 4.40528L15.0338 4.50918L14.0365 5.50644C14.2443 5.58954 14.4312 5.69342 14.5974 5.81808L15.4908 4.9247L15.5958 5.51959C15.6072 5.58408 15.6632 5.63109 15.7287 5.63109C15.7855 5.63109 15.8362 5.59559 15.8556 5.54225L16.6543 3.3457L14.4583 4.14426Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5626_9854",
    x: -13.3337,
    y: -25.8337,
    width: 60.0003,
    height: 60.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.33333,
    result: "effect1_foregroundBlur_5626_9854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5626_9854",
    x: -5.83366,
    y: -31.6667,
    width: 55.0003,
    height: 55.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.33333,
    result: "effect1_foregroundBlur_5626_9854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5626_9854",
    x: -43.333,
    y: -10,
    width: 80.833,
    height: 80.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_5626_9854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5626_9854"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium-icon.be174478554f60009beb7403c25ce717.svg";
export { ForwardRef as ReactComponent };